//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-notify',
  mounted () {
    document.title = '被保险人告知'
    this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=notify&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
    })
  },
  data () {
    return {
      fit: true
    }
  },
  created () {
    const fitInStore = window.sessionStorage.getItem('fit')
    if (fitInStore === 'false') {
      this.fit = false
    }
  },
  computed: {
    notifies () {
      if (this.$store.state.config.notifies) return this.$store.state.config.notifies.list
    },
    themeColor () {
      if (this.$store.state.config.themeColor) return this.$store.state.config.themeColor
    },
    isAeonlife () {
      if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
        return true
      }
      return false
    }
  },
  methods: {
    next () {
      let strSpan = '"position: absolute;left: -.9rem;top: 0;display: inline-block;border-radius: 50%;width: .8rem;height: .8rem;background: #fff;padding: .1rem;text-align: center;line-height: .8rem;border: 1px solid #ccc;margin-right: .3rem;margin-left: .3rem;"'
      let strParagraph = '"position: relative;border-left: 1px solid #ccc;padding-bottom: 1rem;padding-left: 1rem;box-sizing: border-box;font-size: .875rem;margin-left: .5rem;text-align: left;color: #303030;"'
      let strParagraphlast = '"position: relative;padding-bottom: 1rem;padding-left: 1rem;box-sizing: border-box;font-size: .875rem;margin-left: .5rem;text-align: left;color: #303030;"'
      if (this.fit !== true && this.fit !== false) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请确认被保险人是否具有以上情况',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.fit === false) {
        // this.$vux.toast.show({
        //   type: 'text',
        //   text: '客官，您的告知不符合投保要求，谢谢惠顾',
        //   position: 'top',
        //   width: '20em'
        // })
        // return
        if (this.isAeonlife) { // 是百年的产品
          const _this = this
          window.sessionStorage.setItem('fit', _this.fit)
          _this.$vux.confirm.show({
            title: '申请健康告知',
            content: '<p style="text-align: left;line-height: 1.625rem;color: #303030;font-size: 1rem;margin-bottom: .5rem;">如果您对某个健康状况不确认，可点击申请健康告知继续完成投保：</p><p style=' + strParagraph + '><span style=' + strSpan + '>1</span>填写投保信息</p><p style=' + strParagraph + '><span style=' + strSpan + '>2</span>提供健康告知资料</p><p style=' + strParagraph + '><span style=' + strSpan + '>3</span>保险公司审核资料</p><p style=' + strParagraphlast + '><span style=' + strSpan + '>4</span>审核通过并完成支付</p>',
            confirmText: '申请健康告知',
            cancelText: '取消',
            onCancel () {
            },
            onConfirm () {
              _this.$router.push({name: _this.$store.state.config.policy.path || 'Form', params: {productCode: _this.$store.state.app.productCode, innerCode: _this.$store.state.app.innerCode}, query: _this.$route.query})
            }
          })
        } else {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，您的告知不符合投保要求，谢谢惠顾',
            position: 'top',
            width: '20em'
          })
        }
      } else {
        window.sessionStorage.setItem('fit', this.fit)
        this.$router.push({name: this.$store.state.config.policy.path || 'Form', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode}, query: this.$route.query})
      }
    },
    aeonlifeUnderwriting () {
      this.$vux.alert.show({
        title: '线下核保',
        content: '系统维护中',
        buttonText: '我知道了',
        onShow () {
        }
      })
      // let backURL = encodeURIComponent(window.location.href.replace('/notify', '/form'))
      // window.location.href = '/aeonlife/underwriting?orderUrl=' + backURL + '&productCode=' + this.$store.state.app.productCode
    },
    fitfalse () {
      let strSpanfit = '"position: absolute;left: -.9rem;top: 0;display: inline-block;border-radius: 50%;width: .8rem;height: .8rem;background: #fff;padding: .1rem;text-align: center;line-height: .8rem;border: 1px solid #ccc;margin-right: .3rem;margin-left: .3rem;"'
      let strParagraphfit = '"position: relative;border-left: 1px solid #ccc;padding-bottom: 1rem;padding-left: 1rem;box-sizing: border-box;font-size: .875rem;margin-left: .5rem;text-align: left;color: #303030;"'
      let strParagraphlastfit = '"position: relative;padding-bottom: 1rem;padding-left: 1rem;box-sizing: border-box;font-size: .875rem;margin-left: .5rem;text-align: left;color: #303030;"'
      if (this.isAeonlife) { // 是百年的产品
        const _this = this
        _this.fit = false
        window.sessionStorage.setItem('fit', _this.fit)
        // 百年线下弹框核保文案修改后
        _this.$vux.confirm.show({
          title: '申请健康告知',
          content: '<p style="text-align: left;line-height: 1.625rem;color: #303030;font-size: 1rem;margin-bottom: .5rem">如果您对某个健康状况不确认，可点击申请健康告知继续完成投保：</p><p style=' + strParagraphfit + '><span style=' + strSpanfit + '>1</span>填写投保信息</p><p style=' + strParagraphfit + '><span style=' + strSpanfit + '>2</span>提供健康告知资料</p><p style=' + strParagraphfit + '><span style=' + strSpanfit + '>3</span>保险公司审核资料</p><p style=' + strParagraphlastfit + '><span style=' + strSpanfit + '>4</span>审核通过并完成支付</p>',
          confirmText: '申请健康告知',
          cancelText: '取消',
          onCancel () {
          },
          onConfirm () {
            _this.$router.push({name: _this.$store.state.config.policy.path || 'Form', params: {productCode: _this.$store.state.app.productCode, innerCode: _this.$store.state.app.innerCode}, query: _this.$route.query})
          }
        })
        // 百年线下弹框核保文案修改前
        // _this.$vux.confirm.show({
        //   title: '健康状况不符',
        //   content: '<p style="text-align: left; line-height: 1.625rem;color: #303030; margin-top: .5rem;">您需要提供疾病相关信息，最终是否承保以保险公司审核结果为准</p><p style="text-align: left;background: #f6f6f6;font-size: .875rem;padding: .5rem;line-height: 1.5rem; margin-top: .5rem;">疾病信息包括：疾病名称、发病时间、发病频率和治疗情况</p>',
        //   confirmText: '继续投保',
        //   cancelText: '取消',
        //   onCancel () {
        //   },
        //   onConfirm () {
        //     _this.$router.push({name: _this.$store.state.config.policy.path || 'Form', params: {productCode: _this.$store.state.app.productCode, innerCode: _this.$store.state.app.innerCode}, query: _this.$route.query})
        //   }
        // })
      } else {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，您的告知不符合投保要求，谢谢惠顾',
          position: 'top',
          width: '20em'
        })
      }
      this.fit = false
      window.sessionStorage.setItem('fit', this.fit)
    },
    fittrue () {
      this.fit = true
      window.sessionStorage.setItem('fit', this.fit)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Notify.vue